export const equipmentOptionQtySet = (state, action) => {
    if (action.optionCode) {
        const selectedOptions = state.getIn(['workOrderDetails', action.orderId, 'equipmentOptions', 'selectedOptions']);
        const newOption = {
            'code': action.optionCode,
            'quantity': action.quantity
        };

        if (selectedOptions) {
            const existingOption = selectedOptions.find(function (element) {
                return element.code === action.optionCode;
            });

            if (existingOption) {
                const index = selectedOptions.indexOf(existingOption);
                if (index !== -1) {
                    selectedOptions.splice(index, 1);
                }
            }

            selectedOptions.push(newOption);

            return state.setIn([
                'workOrderDetails', action.orderId, 'equipmentOptions', 'selectedOptions'
            ], selectedOptions).setIn([
                'workOrderDetails', action.orderId, 'equipmentOptions', 'submitSuccess'
            ], null).setIn([
                'workOrderDetails', action.orderId, 'equipmentOptions', 'submitMessage'
            ], null);

        } else {
            const newOptions = [];
            newOptions.push(newOption);
            return state.setIn([
                'workOrderDetails', action.orderId, 'equipmentOptions', 'selectedOptions'
            ], newOptions).setIn([
                'workOrderDetails', action.orderId, 'equipmentOptions', 'submitSuccess'
            ], null).setIn([
                'workOrderDetails', action.orderId, 'equipmentOptions', 'submitMessage'
            ], null);
        }

    } else {
        return state;
    }
};

export const equipmentOptionClear = (state, action) => {
    return state.setIn([
        'workOrderDetails', action.orderId, 'equipmentOptions', 'selectedOptions'
    ], null).setIn([
        'workOrderDetails', action.orderId, 'equipmentOptions', 'submitting'
    ], false).setIn([
        'workOrderDetails', action.orderId, 'equipmentOptions', 'submittingFinished'
    ], false).setIn([
        'workOrderDetails', action.orderId, 'equipmentOptions', 'submitSuccess'
    ], null).setIn([
        'workOrderDetails', action.orderId, 'equipmentOptions', 'submitMessage'
    ], null);
};

export const equipmentOptionSubmitStarted = (state, action) => {
    return state.setIn([
        'workOrderDetails', action.orderId, 'equipmentOptions', 'submitting'
    ], true).setIn([
        'workOrderDetails', action.orderId, 'equipmentOptions', 'submittingFinished'
    ], false).setIn([
        'workOrderDetails', action.orderId, 'equipmentOptions', 'submitSuccess'
    ], null).setIn([
        'workOrderDetails', action.orderId, 'equipmentOptions', 'submitMessage'
    ], 'Your Request Was Sent...');
};

export const equipmentOptionSubmitFinished = (state, action) => {
    return state.setIn([
        'workOrderDetails', action.orderId, 'equipmentOptions', 'submitting'
    ], false).setIn([
        'workOrderDetails', action.orderId, 'equipmentOptions', 'submittingFinished'
    ], true).setIn([
        'workOrderDetails', action.orderId, 'equipmentOptions', 'submitSuccess'
    ], action.payload.isSuccess).setIn([
        'workOrderDetails', action.orderId, 'equipmentOptions', 'submitMessage'
    ], action.payload.message);
};

export const equipmentOptionSubmitFailed = (state, action) => {
    return state.setIn([
        'workOrderDetails', action.orderId, 'equipmentOptions', 'submitting'
    ], false).setIn([
        'workOrderDetails', action.orderId, 'equipmentOptions', 'submittingFinished'
    ], true).setIn([
        'workOrderDetails', action.orderId, 'equipmentOptions', 'submitSuccess'
    ], false).setIn([
        'workOrderDetails', action.orderId, 'equipmentOptions', 'submitMessage'
    ], 'Failed To Submit Options');
};


// WEBPACK FOOTER //
// ./src/reducers/work-order/equipmentOptions.js